export type OptimizeSrcProps = {
  src: string;
  width: number | string;
  quality?: number | string;
};

/**
 * 원티드 이미지 최적화 URL로 반환
 * @see https://wantedlab.atlassian.net/wiki/spaces/FE/pages/2464972903/CloudFront+Lambda+Function+URL+.
 *
 * @param src
 * @param width
 * @param quality
 * @returns
 */
export function getOptimizeSrc({ src, width, quality = 75 }: OptimizeSrcProps) {
  if (src.startsWith('/')) {
    return src;
  }

  return `https://image.wanted.co.kr/optimize?src=${encodeURIComponent(src)}&w=${width}&q=${
    quality <= 0 || quality > 100 ? 75 : quality
  }`;
}
